// Mock data for Electronico Holdings (funky neon redesign)
// NOTE: This is MOCKED frontend data. Chatbot uses mock replies until backend is wired.

export const NAV_LINKS = [
  { label: 'Divisions', href: '#divisions' },
  { label: 'About Us', to: '/about' },
  { label: 'Industries', to: '/industries' },
  { label: 'Contact', to: '/contact' },
];

export const DIVISION_LINKS = [
  { label: 'Electronic Security', to: '/divisions/electronic-security', desc: 'CCTV, access control, radar & power', icon: 'ShieldCheck', color: '#0ef3fe' },
  { label: 'Contract Manufacturing', to: '/divisions/contract-manufacturing', desc: 'PCB assembly, sourcing & QA', icon: 'Cpu', color: '#088ffe' },
  { label: 'Multi Media Marketing', to: '/divisions/multimedia-marketing', desc: 'Branding, content & campaigns', icon: 'Sparkles', color: '#0a6bd6' },
];

export const HERO = {
  kicker: 'ELECTRONICO HOLDINGS',
  title: 'Innovating Tomorrow, Today',
  subtitle:
    'A diversified technology conglomerate engineering the future across electronic security, precision manufacturing, and bold multimedia marketing.',
  bg: 'https://images.unsplash.com/photo-1561233835-f937539b95b9?w=1200&h=880&fit=crop&crop=entropy&q=80',
  stats: [
    { value: '3', label: 'Core Divisions' },
    { value: '80+', label: 'Global Clients' },
    { value: '3', label: 'Continents' },
    { value: '24/7', label: 'Support' },
  ],
};

export const DIVISIONS = [
  {
    id: 'security',
    name: 'Electronic Security',
    tag: 'SECURE',
    color: 'cyan',
    desc: 'Advanced security solutions for a safer tomorrow \u2014 CCTV, access control and 24/7 monitoring.',
    note: 'Active in Mali, West Africa',
    image:
      'https://images.unsplash.com/photo-1618482914248-29272d021005?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxDQ1RWJTIwc3VydmVpbGxhbmNlfGVufDB8fHx8MTc4ODk0MjIxMnww&ixlib=rb-4.1.0&q=85',
    features: ['CCTV & Surveillance', 'Access Control', 'Perimeter Security', 'Command Centers'],
  },
  {
    id: 'manufacturing',
    name: 'Contract Manufacturing',
    tag: 'BUILD',
    color: 'magenta',
    desc: 'Precision engineering and electronic contract manufacturing with rapid prototyping excellence.',
    note: 'ISO-grade quality control',
    image:
      'https://images.unsplash.com/photo-1592659762303-90081d34b277?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHxQQ0IlMjBjaXJjdWl0fGVufDB8fHx8MTc4ODk0MjIwM3ww&ixlib=rb-4.1.0&q=85',
    features: ['PCB Assembly', 'Rapid Prototyping', 'Quality Testing', 'Volume Production'],
  },
  {
    id: 'marketing',
    name: 'Multi Media Marketing',
    tag: 'CREATE',
    color: 'violet',
    desc: 'Creative solutions that captivate and convert \u2014 branding, campaigns and digital experiences.',
    note: 'Full-funnel creative studio',
    image:
      'https://images.unsplash.com/photo-1519389950473-47ba0277781c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxkaWdpdGFsJTIwbWFya2V0aW5nfGVufDB8fHx8MTc4ODk0MjIxMnww&ixlib=rb-4.1.0&q=85',
    features: ['Brand Strategy', 'Content & Video', 'Performance Ads', 'Web Experiences'],
  },
];

export const REGIONS = [
  { name: 'Africa', desc: 'Active projects in Mali and expanding across West Africa', metric: '5+ Active Projects', color: 'lime', image: 'https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=800&h=600&fit=crop&crop=entropy&q=80' },
  { name: 'Americas', desc: 'Serving clients across North and South America', metric: '50+ Clients', color: 'cyan', image: 'https://images.unsplash.com/photo-1618243526284-b461ac4cb814?w=800&h=600&fit=crop&crop=entropy&q=80' },
  { name: 'Europe', desc: 'Established presence in major European markets', metric: '25+ Partners', color: 'magenta', image: 'https://images.unsplash.com/photo-1677690489325-e6a4d2594d76?w=800&h=600&fit=crop&crop=entropy&q=80' },
];

export const PORTFOLIO = [
  { title: 'Security Operations Center', cat: 'Security', big: true, image: 'https://images.unsplash.com/photo-1708807472445-d33589e6b090?w=1200&h=1000&fit=crop&crop=entropy&q=80' },
  { title: 'PCB Assembly', cat: 'Manufacturing', image: 'https://images.unsplash.com/photo-1532186773960-85649e5cb70b?w=800&h=600&fit=crop&crop=entropy&q=80' },
  { title: 'Brand Campaign', cat: 'Marketing', image: 'https://images.unsplash.com/photo-1532134358497-43fa3c6a02b0?w=800&h=600&fit=crop&crop=entropy&q=80' },
  { title: 'CCTV Systems', cat: 'Security', image: 'https://images.unsplash.com/photo-1618482914248-29272d021005?w=800&h=600&fit=crop&crop=entropy&q=80' },
  { title: 'Quality Control', cat: 'Manufacturing', image: 'https://images.unsplash.com/photo-1580584126903-c17d41830450?w=800&h=600&fit=crop&crop=entropy&q=80' },
];

export const WEB_PROJECTS = [
  {
    name: 'Wipcorp Project Management',
    url: 'https://www.wipcorp.co.za',
    label: 'www.wipcorp.co.za',
    desc: 'Corporate site for a construction, manufacturing & engineering project management firm.',
    image: '/work/wipcorp.jpg',
  },
  {
    name: 'Overberg Gold & Tech',
    url: 'https://www.goldntech.co.za',
    label: 'www.goldntech.co.za',
    desc: 'E-commerce storefront for a gold-buying and pre-owned tech retailer.',
    image: '/work/goldntech.jpg',
  },
];

export const WHY = [
  { title: 'Trusted Security', desc: 'Industry-leading security protecting critical infrastructure worldwide.', icon: 'ShieldCheck', image: 'https://images.unsplash.com/photo-1708807472445-d33589e6b090?w=800&h=600&fit=crop&crop=entropy&q=80' },
  { title: 'Fast Delivery', desc: 'Rapid prototyping and efficient manufacturing with quick turnarounds.', icon: 'Zap', image: 'https://images.unsplash.com/photo-1592659762303-90081d34b277?w=800&h=600&fit=crop&crop=entropy&q=80' },
  { title: 'Expert Team', desc: 'Seasoned professionals with deep industry and technical expertise.', icon: 'Users', image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=600&fit=crop&crop=entropy&q=80' },
  { title: 'Global Presence', desc: 'Operating across Africa, Europe and the Americas with local know-how.', icon: 'Globe', image: 'https://images.unsplash.com/photo-1644088379091-d574269d422f?w=800&h=600&fit=crop&crop=entropy&q=80' },
];

export const INDUSTRIES = [
  { name: 'Mining', icon: 'Pickaxe', color: '#0ef3fe', image: 'https://images.unsplash.com/photo-1622645636770-11fbf0611463?w=800&h=600&fit=crop&crop=entropy&q=80' },
  { name: 'Commercial', icon: 'Building2', color: '#088ffe', image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=600&fit=crop&crop=entropy&q=80' },
  { name: 'Healthcare', icon: 'HeartPulse', color: '#0a6bd6', image: 'https://images.unsplash.com/photo-1596541223130-5d31a73fb6c6?w=800&h=600&fit=crop&crop=entropy&q=80' },
  { name: 'Industrial', icon: 'Factory', color: '#0ef3fe', image: 'https://images.unsplash.com/photo-1689752784205-05109681c803?w=800&h=600&fit=crop&crop=entropy&q=80' },
  { name: 'Energy', icon: 'Fuel', color: '#088ffe', image: 'https://images.unsplash.com/photo-1509390288171-ce2088f7d08e?w=800&h=600&fit=crop&crop=entropy&q=80' },
  { name: 'Wildlife', icon: 'PawPrint', color: '#5bd0ff', image: 'https://images.unsplash.com/photo-1535941339077-2dd1c7963098?w=800&h=600&fit=crop&crop=entropy&q=80' },
];

export const PARTNERS = [
  { name: 'GALLAGHER', domain: 'gallagher.com', logo: '/partners/gallagher.png', zoom: 1.15 },
  { name: 'MAGOS', domain: 'magos-sys.com', logo: '/partners/magos.png' },
  { name: 'FLIR', domain: 'flir.com', logo: '/partners/flir.png' },
  { name: 'FIBERSENSE', domain: 'fibersense.com', logo: '/partners/fibersense.png' },
  { name: 'SMARTVOX', domain: 'smartvox.com', logo: '/partners/smartvox.png', dark: true, zoom: 0.85 },
  { name: 'NEDAP', domain: 'nedap.com', logo: '/partners/nedap.png', light: true, zoom: 0.95 },
  { name: 'MORPHO', domain: 'morpho.com', logo: '/partners/morpho.png' },
  { name: 'MOXA', domain: 'moxa.com', logo: '/partners/moxa.png', light: true, zoom: 1.0 },
  { name: 'AVIGILON', domain: 'avigilon.com', logo: '/partners/avigilon.png', light: true, zoom: 1.1 },
  { name: 'NEMTEK', domain: 'nemtek.com', logo: '/partners/nemtek.png' },
  { name: 'ABLOY', domain: 'abloy.com', logo: '/partners/abloy.png', light: true, zoom: 1.15 },
  { name: 'DAHUA', domain: 'dahuasecurity.com', logo: '/partners/dahua.png', light: true, zoom: 1.1 },
  { name: 'ZKTECO', domain: 'zkteco.com', logo: '/partners/zkteco.png', light: true, zoom: 1.1 },
];

export const FAQS = [
  { q: 'What industries do you serve?', a: 'We serve mining, commercial, healthcare, government, industrial and energy sectors with tailored security, manufacturing and marketing solutions.' },
  { q: 'Do you offer 24/7 support?', a: 'Yes. Our security operations centers and support teams operate around the clock across all active regions.' },
  { q: 'What is your project timeline?', a: 'Timelines vary by scope. Rapid prototypes can ship in days, while full deployments are planned collaboratively with clear milestones.' },
  { q: 'Where are you located?', a: 'Our headquarters are in Hermanus, Western Cape, South Africa, with active operations across Africa, Europe and the Americas.' },
];

export const CONTACT = {
  email: 'info@electronico.co.za',
  phone: '+27 21 020 1435',
  location: 'Hermanus, Western Cape',
};

export const ABOUT =
  'Electronico Holdings is a diversified technology conglomerate committed to delivering excellence across multiple sectors. With decades of combined expertise, our three divisions work synergistically to provide comprehensive solutions in security, manufacturing, and marketing.';

// Electronic Security division dedicated page
export const SECURITY_PAGE = {
  hero: {
    kicker: 'DIVISION 01 / ELECTRONIC SECURITY',
    title: 'Security, Engineered for a Safer Tomorrow',
    subtitle:
      'End-to-end electronic security solutions \u2014 from access control and perimeter defence to radar surveillance, resilient power and mission-critical control rooms.',
    image:
      'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=1600&q=80',
    stats: [
      { value: '24/7', label: 'Monitoring' },
      { value: '6', label: 'Core Capabilities' },
      { value: '99.9%', label: 'Uptime Target' },
      { value: 'Mali+', label: 'Active Regions' },
    ],
  },
  services: [
    {
      id: 'access-control',
      no: '01',
      icon: 'KeyRound',
      title: 'Access Control',
      desc: 'Intelligent access management that puts you in complete control of who goes where, and when \u2014 across single doors or multi-site estates.',
      image: 'https://images.unsplash.com/photo-1697382608786-bcf4c113b86e?w=900&q=80',
      points: ['Biometric & card readers', 'Role-based permissions', 'Visitor & contractor management', 'Full audit trails'],
    },
    {
      id: 'perimeter-security',
      no: '02',
      icon: 'ShieldAlert',
      title: 'Perimeter Security',
      desc: 'Layered perimeter protection that detects, deters and delays intrusions long before they reach your critical assets.',
      image: 'https://images.unsplash.com/photo-1778439570144-1c6c1e9da8c9?w=900&q=80',
      points: ['Electric & smart fencing', 'Intrusion detection', 'Thermal line-of-sight', 'Instant breach alerts'],
    },
    {
      id: 'radars',
      no: '03',
      icon: 'Radar',
      title: 'Early Warning & Detection Systems',
      desc: 'Wide-area detection for early warning across large sites, coastlines and open terrain \u2014 day, night and through weather. Tower-mounted Magos SR-1000 sensors.',
      image: 'https://images.unsplash.com/photo-1783802203244-31ace7d4063f?w=900&h=520&fit=crop&crop=entropy&q=80',
      points: ['Magos SR-1000 MIMO radar', 'Tower & mast mounted', 'Detection up to 1000m', 'All-weather tracking'],
    },
    {
      id: 'backup-power',
      no: '04',
      icon: 'BatteryCharging',
      title: 'Backup Power Systems',
      desc: 'Resilient power that keeps your security infrastructure online through outages \u2014 because protection can never take a break.',
      image: 'https://images.unsplash.com/photo-1732030373864-d37573915751?w=900&q=80',
      points: ['UPS & battery banks', 'Solar & hybrid options', 'Automatic failover', 'Remote power monitoring'],
    },
    {
      id: 'control-rooms',
      no: '05',
      icon: 'MonitorDot',
      title: 'Control Rooms',
      desc: 'Purpose-built command and control rooms that unify every feed, sensor and alarm into one clear operational picture.',
      image: 'https://images.unsplash.com/photo-1708807472445-d33589e6b090?w=900&q=80',
      points: ['Ergonomic operator desks', 'Video wall integration', 'Unified VMS platforms', '24/7 SOC design'],
    },
    {
      id: 'cctv',
      no: '06',
      icon: 'Cctv',
      title: 'CCTV',
      desc: 'High-definition CCTV with AI-driven analytics that turn hours of footage into instant, actionable intelligence.',
      image: 'https://images.unsplash.com/photo-1585206031650-9e9a7c87dcfe?w=900&q=80',
      points: ['4K & low-light cameras', 'AI video analytics', 'Cloud & edge recording', 'ANPR & face detection'],
    },
  ],
  process: [
    { step: '01', title: 'Assess', desc: 'On-site survey & risk assessment of your assets and vulnerabilities.' },
    { step: '02', title: 'Design', desc: 'Tailored, standards-compliant system design and technology selection.' },
    { step: '03', title: 'Deploy', desc: 'Certified installation, integration and rigorous commissioning.' },
    { step: '04', title: 'Support', desc: 'Round-the-clock monitoring, maintenance and rapid response.' },
  ],
};


// Mock chatbot replies (used only until Gemini backend is wired)
export const MOCK_BOT_REPLIES = [
  "Hi! I'm Volt, the Electronico AI assistant. We operate across Electronic Security, Contract Manufacturing and Multimedia Marketing. What can I help you with?",
  'Our Electronic Security division delivers CCTV, access control and 24/7 monitoring \u2014 currently active in Mali, West Africa.',
  'For manufacturing, we handle PCB assembly, rapid prototyping and rigorous quality control. Want a rough timeline?',
];

// Contract Manufacturing division dedicated page (content from client draft)
export const MANUFACTURING_PAGE = {
  hero: {
    kicker: 'DIVISION 02 / CONTRACT MANUFACTURING',
    title: 'Electronic Manufacturing, Done Right',
    subtitle:
      'Partner with Electronico to save time, resources and cost. Deep expertise across a wide range of products and volumes \u2014 manufactured efficiently, delivered on time.',
    image: 'https://images.unsplash.com/photo-1532186773960-85649e5cb70b?w=1400&h=800&fit=crop&crop=entropy&q=80',
    stats: [
      { value: 'On-Time', label: 'Proven Delivery' },
      { value: 'Scalable', label: 'Up or Down' },
      { value: '7', label: 'Core Services' },
      { value: 'End-to-End', label: 'Project Managed' },
    ],
  },
  intro:
    'By partnering with Electronico for electronic contract manufacturing, businesses reduce costs, improve efficiency, and gain access to advanced technology and expertise \u2014 while staying focused on their core competencies.',
  values: [
    { icon: 'Clock', title: 'Save Time & Cost', desc: 'Outsource manufacturing and reclaim the time, resources and cost of running it in-house.' },
    { icon: 'Cpu', title: 'Deep Expertise', desc: 'Deep knowledge of electronic manufacturing across a wide range of products and volumes.' },
    { icon: 'CalendarCheck', title: 'On-Time Delivery', desc: 'A proven track record of meeting deadlines so you can plan schedules with confidence.' },
    { icon: 'Scale', title: 'Scalable Capacity', desc: 'Flex production up or down with market demand \u2014 without significant added cost.' },
  ],
  services: [
    {
      id: 'cost-analysis', no: '01', icon: 'Calculator', title: 'Design Cost Analysis & Sustainability',
      desc: 'New design cost analysis and sustainability review to optimise products before a single part is ordered.',
      image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=900&h=520&fit=crop&crop=entropy&q=80',
      points: ['New design cost analysis', 'Sustainability review', 'Optimise before production'],
    },
    {
      id: 'data-interpretation', no: '02', icon: 'FileSearch', title: 'Design Data Interpretation',
      desc: 'Interpretation of your design data to prepare it fully and accurately for the manufacturing floor.',
      image: 'https://images.unsplash.com/photo-1592659762303-90081d34b277?w=900&h=520&fit=crop&crop=entropy&q=80',
      points: ['Design-to-manufacturing prep', 'Manufacturing-ready data', 'Accurate translation'],
    },
    {
      id: 'data-verification', no: '03', icon: 'BadgeCheck', title: 'Data & Part Number Verification',
      desc: 'A critical step: verifying accuracy and completeness of component data \u2014 part numbers, specifications and traceability \u2014 against manufacturer specs and established databases.',
      image: 'https://images.unsplash.com/photo-1562408590-e32931084e23?w=900&h=520&fit=crop&crop=entropy&q=80',
      points: ['Part number verification', 'Spec & completeness checks', 'Traceability information'],
    },
    {
      id: 'compatibility', no: '04', icon: 'GitCompareArrows', title: 'Component Compatibility',
      desc: 'Compare component specifications against project requirements to confirm compatibility and functionality.',
      image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=900&h=520&fit=crop&crop=entropy&q=80',
      points: ['Spec vs requirement match', 'Compatibility confirmation', 'Functionality assurance'],
    },
    {
      id: 'sourcing', no: '05', icon: 'PackageSearch', title: 'Component Sourcing & Kit Preparation',
      desc: 'Source components and prepare kits, verifying traceability \u2014 origin, manufacturer and lot numbers \u2014 for full quality-standard compliance.',
      image: 'https://images.unsplash.com/photo-1580584126903-c17d41830450?w=900&h=520&fit=crop&crop=entropy&q=80',
      points: ['Component sourcing', 'Kit preparation', 'Origin, manufacturer & lot traceability'],
    },
    {
      id: 'forecasting', no: '06', icon: 'LineChart', title: 'Raw Material Planning & Forecasting',
      desc: 'Strategic planning and forecasting of raw material to ensure uninterrupted continuity of production.',
      image: 'https://images.unsplash.com/photo-1601598851547-4302969d0614?w=900&h=520&fit=crop&crop=entropy&q=80',
      points: ['Strategic material planning', 'Demand forecasting', 'Production continuity'],
    },
    {
      id: 'project-management', no: '07', icon: 'ClipboardList', title: 'Assembly Project Management',
      desc: 'Project manage the assembly process end to end \u2014 minimising disruptions, reducing costs and delivering reliable products on time.',
      image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=900&h=520&fit=crop&crop=entropy&q=80',
      points: ['Start-to-finish management', 'Fewer disruptions', 'Reliable, on-time delivery'],
    },
  ],
  whyOutsource: [
    { icon: 'SlidersHorizontal', title: 'Choose Your Level of Control' },
    { icon: 'Award', title: 'Gain Procurement Expertise' },
    { icon: 'Wallet', title: 'Lower Your Costs' },
    { icon: 'Target', title: 'Return to Your Core Focus' },
    { icon: 'Globe', title: 'Enjoy Greater Access' },
    { icon: 'RefreshCw', title: 'Adapt to Change Quickly' },
    { icon: 'Gauge', title: 'Streamline Productivity' },
  ],
  outro:
    'We have a history of reliable business process outsourcing. Outsource with us to keep your data secure and streamline procurement \u2014 your satisfaction and security are our highest concern, and your success is the goal.',
};


// Multi Media Marketing division dedicated page
export const MARKETING_PAGE = {
  hero: {
    kicker: 'DIVISION 03 / MULTI MEDIA MARKETING',
    title: 'Creative That Captivates & Converts',
    subtitle:
      'A full-funnel creative studio blending bold branding, cinematic content and data-driven campaigns \u2014 built to make audiences stop, feel and act.',
    image: 'https://images.unsplash.com/photo-1532134358497-43fa3c6a02b0?w=1400&h=800&fit=crop&crop=entropy&q=80',
    stats: [
      { value: 'Full-Funnel', label: 'Strategy to Sale' },
      { value: '360\u00b0', label: 'Creative Studio' },
      { value: '6', label: 'Core Services' },
      { value: 'Data-Led', label: 'Every Campaign' },
    ],
  },
  intro:
    'From the first spark of an idea to the last click of a conversion, our team crafts creative solutions that captivate audiences and drive real, measurable growth for your brand.',
  values: [
    { icon: 'Sparkles', title: 'Bold Creative', desc: 'Ideas that break through the noise and make your brand impossible to ignore.' },
    { icon: 'BarChart3', title: 'Data-Driven', desc: 'Every decision backed by analytics, testing and real performance insight.' },
    { icon: 'Rocket', title: 'Growth Focused', desc: 'Campaigns engineered to move the metrics that matter to your business.' },
    { icon: 'Users', title: 'Audience First', desc: 'Deep audience understanding so every message lands with the right people.' },
  ],
  services: [
    {
      id: 'brand-strategy', no: '01', icon: 'Palette', title: 'Brand Strategy & Identity',
      desc: 'Positioning, messaging and visual identity that give your brand a clear, unforgettable voice.',
      image: 'https://images.unsplash.com/photo-1513807762437-8c8dee6b3776?w=900&h=520&fit=crop&crop=entropy&q=80',
      points: ['Brand positioning', 'Logo & visual identity', 'Tone & messaging', 'Brand guidelines'],
    },
    {
      id: 'content-video', no: '02', icon: 'Video', title: 'Content & Video Production',
      desc: 'Cinematic video and scroll-stopping content produced end to end \u2014 concept, shoot and edit.',
      image: 'https://images.unsplash.com/photo-1625690303837-654c9666d2d0?w=900&h=520&fit=crop&crop=entropy&q=80',
      points: ['Video production', 'Photography', 'Motion graphics', 'Post-production'],
    },
    {
      id: 'performance-ads', no: '03', icon: 'TrendingUp', title: 'Performance Advertising',
      desc: 'Paid campaigns across search, social and display \u2014 optimised relentlessly for ROI.',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=900&h=520&fit=crop&crop=entropy&q=80',
      points: ['Paid search & social', 'Audience targeting', 'A/B testing', 'ROI optimisation'],
    },
    {
      id: 'social-media', no: '04', icon: 'Share2', title: 'Social Media Management',
      desc: 'Always-on social that builds community, sparks conversation and grows your following.',
      image: 'https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=900&h=520&fit=crop&crop=entropy&q=80',
      points: ['Content calendars', 'Community management', 'Influencer collabs', 'Social analytics'],
    },
    {
      id: 'web-experiences', no: '05', icon: 'MonitorSmartphone', title: 'Web & Digital Experiences',
      desc: 'High-converting websites and interactive experiences that feel as good as they perform.',
      image: 'https://images.unsplash.com/photo-1611784728558-6c7d9b409cdf?w=900&h=520&fit=crop&crop=entropy&q=80',
      points: ['Web design & build', 'Landing pages', 'UX & CRO', 'Interactive experiences'],
    },
    {
      id: 'campaigns', no: '06', icon: 'Megaphone', title: 'Integrated Campaigns',
      desc: 'Big-idea campaigns that connect every channel into one cohesive, memorable story.',
      image: 'https://images.unsplash.com/photo-1533750516457-a7f992034fec?w=900&h=520&fit=crop&crop=entropy&q=80',
      points: ['Campaign strategy', 'Cross-channel rollout', 'Creative direction', 'Reporting & insights'],
    },
  ],
  process: [
    { step: '01', title: 'Discover', desc: 'We dig into your brand, audience and goals to find the real opportunity.' },
    { step: '02', title: 'Create', desc: 'Big ideas turned into bold, on-brand creative across every channel.' },
    { step: '03', title: 'Launch', desc: 'Campaigns go live, finely targeted and ready to perform.' },
    { step: '04', title: 'Optimise', desc: 'We measure, learn and refine to keep growth compounding.' },
  ],
  outro:
    "Let's create something audiences can't ignore. Tell us your goals and we'll craft the campaign to get you there.",
};


// About Us dedicated page
export const ABOUT_PAGE = {
  hero: {
    kicker: 'ABOUT ELECTRONICO HOLDINGS',
    title: 'One Group. Three Powerhouses.',
    subtitle:
      'Electronico Holdings is a diversified technology conglomerate delivering excellence across electronic security, contract manufacturing and multimedia marketing \u2014 from our home in Hermanus to clients across three continents.',
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=1400&h=800&fit=crop&crop=entropy&q=80',
    stats: [
      { value: '3', label: 'Core Divisions' },
      { value: '80+', label: 'Global Clients' },
      { value: '3', label: 'Continents' },
      { value: '24/7', label: 'Support' },
    ],
  },
  story: [
    'Electronico Holdings was built on a simple belief: that deep technical expertise, delivered with genuine care, creates lasting value for the people and businesses we serve.',
    'With decades of combined experience, our three divisions operate synergistically \u2014 sharing engineering talent, quality standards and a relentless commitment to getting the details right.',
    'The result is a single, trusted partner that can secure your premises, manufacture your electronics and grow your brand \u2014 all under one roof.',
  ],
  mv: [
    { icon: 'Target', title: 'Our Mission', desc: 'To deliver comprehensive, world-class technology solutions that empower our clients to succeed \u2014 safely, efficiently and boldly.' },
    { icon: 'Eye', title: 'Our Vision', desc: 'To be Africa\u2019s most trusted diversified technology group, known for engineering excellence and unwavering integrity.' },
  ],
  values: [
    { icon: 'ShieldCheck', title: 'Integrity', desc: 'We do what we say, protect what matters and keep your data and trust secure.', image: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=800&h=600&fit=crop&crop=entropy&q=80' },
    { icon: 'Zap', title: 'Excellence', desc: 'Rigorous quality and craftsmanship in everything we design, build and deliver.', image: 'https://images.unsplash.com/photo-1769147339214-076740872485?w=800&h=600&fit=crop&crop=entropy&q=80' },
    { icon: 'Users', title: 'Partnership', desc: 'We work as an extension of your team, invested in your long-term success.', image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=600&fit=crop&crop=entropy&q=80' },
    { icon: 'Rocket', title: 'Innovation', desc: 'We embrace new technology to keep our clients a step ahead of the curve.', image: 'https://images.unsplash.com/photo-1529854140025-25995121f16f?w=800&h=600&fit=crop&crop=entropy&q=80' },
  ],
  divisions: [
    { label: 'Electronic Security', to: '/divisions/electronic-security', icon: 'ShieldCheck', color: '#0ef3fe', image: 'https://images.unsplash.com/photo-1618482914248-29272d021005?w=800&h=600&fit=crop&crop=entropy&q=80' },
    { label: 'Contract Manufacturing', to: '/divisions/contract-manufacturing', icon: 'Cpu', color: '#088ffe', image: 'https://images.unsplash.com/photo-1592659762303-90081d34b277?w=800&h=600&fit=crop&crop=entropy&q=80' },
    { label: 'Multi Media Marketing', to: '/divisions/multimedia-marketing', icon: 'Sparkles', color: '#0a6bd6', image: 'https://images.unsplash.com/photo-1532134358497-43fa3c6a02b0?w=800&h=600&fit=crop&crop=entropy&q=80' },
  ],
};


// Industries dedicated page
export const INDUSTRIES_PAGE = {
  hero: {
    kicker: 'INDUSTRIES WE SERVE',
    title: 'Built for Every Environment',
    subtitle:
      'From remote mines to city hospitals, our security, manufacturing and marketing solutions are tailored to the realities of each sector we serve.',
    image: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=1400&h=800&fit=crop&crop=entropy&q=80',
    stats: [
      { value: '6', label: 'Key Sectors' },
      { value: '80+', label: 'Clients Served' },
      { value: '3', label: 'Continents' },
      { value: '24/7', label: 'Support' },
    ],
  },
  items: [
    { name: 'Mining', icon: 'Pickaxe', color: '#0ef3fe', image: 'https://images.unsplash.com/photo-1622645636770-11fbf0611463?w=800&h=600&fit=crop&crop=entropy&q=80' },
    { name: 'Commercial', icon: 'Building2', color: '#088ffe', image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=600&fit=crop&crop=entropy&q=80' },
    { name: 'Healthcare', icon: 'HeartPulse', color: '#0a6bd6', image: 'https://images.unsplash.com/photo-1596541223130-5d31a73fb6c6?w=800&h=600&fit=crop&crop=entropy&q=80' },
    { name: 'Industrial', icon: 'Factory', color: '#0ef3fe', image: 'https://images.unsplash.com/photo-1689752784205-05109681c803?w=800&h=600&fit=crop&crop=entropy&q=80' },
    { name: 'Energy', icon: 'Fuel', color: '#088ffe', image: 'https://images.unsplash.com/photo-1509390288171-ce2088f7d08e?w=800&h=600&fit=crop&crop=entropy&q=80' },
    { name: 'Wildlife', icon: 'PawPrint', color: '#5bd0ff', image: 'https://images.unsplash.com/photo-1535941339077-2dd1c7963098?w=800&h=600&fit=crop&crop=entropy&q=80' },
  ],
  outro:
    "Don't see your sector? Our solutions adapt to almost any environment \u2014 talk to us about your specific requirements.",
};

